<template>
  <v-card 
    class="py-4"
    color="white"
    rounded="lg"
    variant="flat"
  >
    <div class="kiwi-card-container auth-card-container py-3 px-3 px-md-6 px-lg-8">
      <div class="card-header">
        <div class="text-center mt-4">
          <h1 class="kiwi-fs-28 font-weight-semi-bold">
            <template v-if="initialView">Join <router-link class="home-link" to="/">{{ institute.name }}</router-link> today!</template>
            <template v-else>Add Details</template>
          </h1>
          <p class="kiwi-fs-14 mt-1 kiwi-text-light-black-2">
            Enter your credentials to create your account
          </p>
        </div>
      </div>
      <div class="card-body mt-4">
        <div class="kiwi-form-msg text-center">
          <span
            class="kiwi-text-error"
            :class="
              errorMessage.storemsg && errorMessage.storemsg.error ? 'mb-4' : ''
            "
            v-if="errorMessage.storemsg && errorMessage.storemsg.error"
            >{{ errorMessage.storemsg.error }}</span
          >
        </div>
        <v-form @submit="initialView ? nextView : register">
          <div class="initial-view" v-if="initialView">
            <div
              class="kiwi-form-group form-group"
              :class="
                errorMessage.email ||
                (errorMessage.storemsg && errorMessage.storemsg.email)
                  ? 'kiwi-form-error'
                  : formData.email !== null
                  ? 'kiwi-form-success'
                  : ''
              "
            >
              <label for="" class="kiwi-form-label"
                >Email Address
                <span class="kiwi-required kiwi-text-error">*</span></label
              >
              <v-text-field
                type="email"
                variant="outlined"
                v-model="formData.email"
                class="kiwi-form-input kiwi-radius-4"
                placeholder="abc@gmail.com"
                @input="inputUpdate"
                @keypress.enter="nextView"
                :error-messages="formValidation?.email"
                :rules="[handleErrors.rules.required, handleErrors.rules.email]"
              ></v-text-field>
              <!-- <span
                class="form-msg d-block mt-2"
                v-if="
                  errorMessage.email ||
                  (errorMessage.storemsg && errorMessage.storemsg.email)
                "
              >
                <span
                  class="kiwi-text-error d-block"
                  v-if="errorMessage.email"
                  >{{ errorMessage.email }}</span
                >
                <span
                  class="kiwi-text-error d-block"
                  v-if="errorMessage.storemsg && errorMessage.storemsg.email"
                  >{{ errorMessage.storemsg.email[0] }}</span
                >
              </span> -->
            </div>
            <div
              class="kiwi-form-group form-group mt-2"
              :class="
                errorMessage.password ||
                (errorMessage.storemsg && errorMessage.storemsg.password)
                  ? 'kiwi-form-error'
                  : formData.password !== null
                  ? 'kiwi-form-success'
                  : ''
              "
            >
              <label for="" class="kiwi-form-label"
                >Password
                <span class="kiwi-required kiwi-text-error">*</span></label
              >
              <v-text-field
                :type="toggleEye ? 'password' : 'text'"
                v-model="formData.password"
                :append-inner-icon="toggleEye ? 'mdi-eye' : 'mdi-eye-off'"
                variant="outlined"
                class="kiwi-form-input kiwi-radius-4 kiwi-position-relative z-1 w-100"
                placeholder="Enter your password"
                @input="inputPassword"
                @click:append-inner="togglePassword"
                @keypress.enter="nextView"
                :error-messages="formValidation.password"
                :rules="[handleErrors.rules.required, handleErrors.rules.password]"
              />
            </div>
            <div class="kiwi-form-btnwrap mt-6">
              <v-btn
                class="text-none text-uppercase mb-4 text-body-1 kiwi-bg-primary kiwi-text-white"
                size="x-large"
                variant="flat"
                height="56"
                block
                :disabled="!isValid || (!formData.email, !formData.password)"
                :class="
                  !isValid || (!formData.email, !formData.password)
                    ? 'kiwi-button-disable kiwi-bg-disabled'
                    : ''
                "
                @click="nextView"
              >
                Next
              </v-btn>
            </div>
            <template v-if="institute.$hasFeature('google-signup') || institute.$hasFeature('facebook-signup')">
            <v-row class="kiwi-or-divider align-center">
              <v-col cols
                ><v-divider class="kiwi-border-lightes-grey kiwi-no-opacity"
              /></v-col>
              <v-col cols="3" md="2"><div class="kiwi-fs-14 text-center text-uppercase font-weight-semi-bold kiwi-text-light-grey">OR</div></v-col>
              <v-col cols
                ><v-divider class="kiwi-border-lightes-grey kiwi-no-opacity"
              /></v-col>
            </v-row>
            <v-row class="kiwi-form-social-btn-wrap">
              <v-col cols="12" :md="institute.$hasFeature('google-signup') && institute.$hasFeature('facebook-signup') ? 6 : 12" v-if="institute.$hasFeature('google-signup')">
                <div>
                  <v-btn
                    class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                    color="default"
                    size="large"
                    variant="flat"
                    block
                    v-if="!isGoogleUser"
                    @click.prevent="fetchGoogle"
                    :disabled="isProcessing"
                  >
                    <img
                      src="@/assets/icon_google.png"
                      class="mr-2 size-18"
                      alt="Facebook Icon"
                    />
                    Sign up with Google
                  </v-btn>
                  <v-btn
                    v-else
                    class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                    color="default"
                    size="large"
                    variant="flat"
                    block
                    @click.prevent="fetchGoogle"
                    :disabled="isProcessing"
                  >
                    <div class="d-flex kiwi-minus-mx-15">
                      <div class="d-flex mr-2 align-center">
                        <div
                          class="circle mr-1"
                          style="width: 18px; height: 18px"
                          v-if="isGoogleUser && isGoogleUser.photoURL"
                        >
                          <img :src="isGoogleUser.photoURL" class="size-18" alt="Google Icon" />
                        </div>
                        <div class="font-weight-semi-bold">
                          Sign up as
                          <span class="text-capitalize">{{
                            isGoogleUser ? `${isGoogleUser.displayName}` : ""
                          }}</span>
                          <br />
                          <span class="font-weight-regular">{{
                            isGoogleUser ? isGoogleUser.email : ""
                          }}</span>
                        </div>
                      </div>
                      <img
                        src="@/assets/icon_google.png"
                        alt="Facebook Icon"
                        class=" size-18"
                      />
                    </div>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" :md="institute.$hasFeature('google-signup') && institute.$hasFeature('facebook-signup') ? 6 : 12" v-if="institute.$hasFeature('facebook-signup')">
                <v-btn
                  class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                  color="default"
                  size="large"
                  variant="flat"
                  block
                  v-if="!isFacebookUser"
                  @click.prevent="fetchfacebook"
                  :disabled="isProcessing"
                >
                  <img
                    src="@/assets/icon_facebook.png"
                    class="mr-2 size-18"
                    alt="Facebook Icon"
                  />
                  Sign up with Facebook
                </v-btn>
                <v-btn
                  class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                  color="default"
                  size="large"
                  variant="flat"
                  block
                  v-else
                  @click.prevent="fetchfacebook"
                  :disabled="isProcessing"
                >
                  <div class="d-flex kiwi-minus-mx-15">
                    <div class="d-flex mr-2 align-center">
                      <div
                        class="circle mr-1"
                        style="width: 18px; height: 18px"
                        v-if="isFacebookUser && isFacebookUser.photoURL"
                      >
                        <img :src="isFacebookUser.photoURL" class=" size-18" alt="Google Icon" />
                      </div>
                      <div class="font-weight-semi-bold">
                        Sign up as
                        <span class="text-capitalize">{{
                          isFacebookUser ? `${isFacebookUser.displayName}` : ""
                        }}</span>
                      </div>
                    </div>
                    <img
                      src="@/assets/icon_facebook.png"
                      alt="Facebook Icon"
                      class=" size-18"
                    />
                  </div>
                </v-btn>
              </v-col>
            </v-row>
            </template>

            <div class="kiwi-form-footer-wrap mt-4 text-center">
              <router-link
                :to="'/login'"
                @click.prevent="routerLinkCliecked"
                class="font-weight-medium text-none text-decoration-none kiwi-text-light-black-2"
                >{{ `Already have an account?` }}
                <span class="font-weight-semi-bold kiwi-text-primary">{{
                  "Sign In"
                }}</span></router-link
              >
            </div>
          </div>
          <DetailForm v-else-if="!initialView" @backToInitialView="handleBackToIntialView"/>
        </v-form>
      </div>
    </div>

    <SnackBar />
  </v-card>
</template>

<script setup>
import { apiWithoutAuth } from "@/plugins/axios";
import {
  useSocialLogin,
  isProcessing,
} from "@/composables/useSocialLogin";
import SnackBar from "@/components/SnackBar.vue";
import DetailForm from "@/components/Auth/DetailForm.vue";
import { useKiwiFormValidationCheck } from "@/stores/kiwiFormValidation";
import { useRegisterStore } from "@/stores/registrationStore";
import { storeToRefs } from "pinia";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useConfirmer } from "@/stores/confirmer";
import { useValidation } from "@/composables/useValidation";
import { useInstituteStore } from '@/stores/institute/institute-store';
const institute = useInstituteStore()
import { AuthTokenService } from '@/handler/authService'
import { useRoute } from 'vue-router'

const route = useRoute()

const hasRefCode = computed(() => {
    return Object.keys(route.query).includes('ref_code')
})

const router = useRouter();
const auth = useRegisterStore();
const { validate } = auth;
const confirmer = useConfirmer();
const validation = useKiwiFormValidationCheck();
const { formData, authState } = storeToRefs(auth);
const { isValid, errorMessage } = storeToRefs(validation);
const isAuthenticated = ref(false);
validation.clearApiValidation();
const initialView = ref(true);
const formValidation = ref({})
const handleErrors = useValidation();
const isGoogleUser = ref(null)
const isFacebookUser = ref(null)


router.currentRoute._value.query.detailForm === "open"
  ? (initialView.value = false)
  : (initialView.value = true);

JSON.parse(localStorage.getItem("token"))
  ? (isAuthenticated.value = true)
  : (isAuthenticated.value = false);

const routerLinkCliecked = () => {
  validation.clearApiValidation();
  if (isAuthenticated.value === true) {
    isAuthenticated.value = false;
  }
};

const inputUpdate = () => {
  validation.clearApiValidation();
  validation.validEmail(auth.formData.email);
};

const inputPassword = () => {
  validation.clearApiValidation();
  validation.validPassword(auth.formData.password);
};

const nextView = async () => {
  try {
    await validate();
    if (
      auth.formData.email !== null &&
      auth.formData.password !== null &&
      validation.isValid
    ) {
      initialView.value = false;
    }
  } catch (error) {
    console.log(validation)
    formValidation.value = error.response.data.data
    // confirmer.openSnackBar({
    //   type: "error",
    //   msg:
    //     error.response.data.data.email[0]  ||
    //     "Somthing Went Wrong Please Try Again",
    // });
  }
};

const toggleType = ref("password");
const toggleEye = ref(true);
toggleEye.value ? (toggleType.value = "password") : (toggleType.value = "text");
const togglePassword = () => {
  toggleEye.value = !toggleEye.value;
};
const socialAuth = useSocialLogin(validation, confirmer);
const fetchGoogle = () => {
  socialAuth.signInWithGoogleMethod();
};
const fetchfacebook = () => {
  socialAuth.signInWithFacebookMethod();
};

onMounted(() => {
  if(hasRefCode.value){
    AuthTokenService.setCookie('REF_CODE', route.query.ref_code)
  }
})
const handleBackToIntialView = () => {
  initialView.value = true;
}
</script>
